import { addNav } from '@/mixins';

export default {
  mixins: [addNav],
  computed: {
    editContent() {
      return this.$refs.editContent;
    },
    addForm() {
      return this.$refs.addForm;
    },
    API() {
      return this.$API;
    },
  },
  mounted() {
    this.$_post(this.$API.listRiskTipDict, {
      data: {},
    }).then((res) => {
      this.paramList = res.data.list?.map(item => ({
        value: item.dictValue,
        label: item.dictName,
      }));
    });
  },

  methods: {
    handlePaste(e) {
      e.preventDefault();
      const clipboard = e.clipboardData;
      if (!clipboard.items || !clipboard.items.length) {
        return;
      }
      let text;
      text = clipboard.getData('text/html') || '';
      if (text !== '') {
        // chrome 49复制带空格 ，body html标签，原因不明
        text = text
          .replace(/<div><br>(.*?)<\/div>/g, '<br>$1')
          .replace(/<div>(.*?)<br><\/div>/g, '$1<br>')
          .replace(/<div[^>/].*?>(.*?)<\/div>/g, '<br>$1')
          .replace(/<(?![input|br]).*?>/g, '')
          .replace(/<body>/, '')
          .replace(/\^s/, '');
        document.execCommand('insertHTML', false, text.trim());
      } else {
        text = clipboard.getData('text/plain');
        document.execCommand('insertText', false, text.trim());
      }
    },
    handleContentBlur() {
      this.addData.riskTipDetails = this.parseHTML(this.editContent.childNodes);
      this.addForm.validateField('riskTipDetails');
    },
    handleCancelClick(page) {
      this.$_yh_confirm('取消后信息将不保存').then(() => {
        this.$store.commit('removeTab', page);
        this.addNav({
          path: '/risk-tip',
          name: '风险话术',
        });
      });
    },
    handleCommand(v) {
      this.editContent.innerHTML = `${this.editContent.innerHTML}<input style="width: ${v.label
        .length + 1.3}em" readonly class="button--blue" data-value="${v.value}" value="{${
        v.label
      }}"/>`;
    },
    parseHTML(nodes, realValue) {
      return [...nodes].reduce((acc, v) => {
        if (v.nodeName === 'INPUT') {
          if (realValue) {
            return `${acc}{{${v.dataset.value}}}`;
          }
          return `${acc}${v.value}`;
        }
        if (v.nodeName === '#text') {
          return `${acc}${v.nodeValue}`;
        }
        if (
          v.nodeName === 'BR'
          && v.nextSibling?.nodeName === '#text'
          && v.previousSibling?.nodeName === '#text'
        ) {
          return `${acc}\n`;
        }
        const len = v.childNodes.length;
        if (len) {
          return `${acc}\n${this.parseHTML(v.childNodes, realValue)}`;
        }
        return acc;
      }, '');
    },
    postRiskTip(api, path) {
      const apiMap = {
        [this.$API.updateRiskTip]: this.$MSG.M0119,
        [this.$API.postRiskTip]: this.$MSG.M0118,
      };
      return this.$_post(api, {
        data: {
          ...this.addData,
          riskTipDetails: this.parseHTML(this.editContent.childNodes, true),
          variableHtml: this.addData.riskTipDetails,
        },
      }).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(apiMap[api]);
          this.$store.commit('removeTab', path);
          this.addNav({
            path: '/risk-tip',
            name: '风险话术',
          });
        } else if (res.errorCode === this.$CODE.duplicatedTipName) {
          this.$message.warning(this.$MSG.M0117);
        }
      });
    },
    handleSaveClick(api, path) {
      this.addData.riskTipDetails = this.parseHTML(this.editContent.childNodes);
      this.addForm.validate((valid) => {
        if (valid) {
          this.postRiskTip(api, path);
        }
      });
    },
  },
};
